'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { CONTACT, MARKETING_CONTACT_DEPRECATED, USER } from 'self-service-api/constants/UnitTypes';
import styled from 'styled-components';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import UIImage from 'UIComponents/image/UIImage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import UIBadge from 'UIComponents/badge/UIBadge';
import { currentSkuIdForProductSelector, skuSelector } from '../../../selectors/ProductsSelectors';
import { CRM_SUITE_PRODUCTS } from 'pricing-pages-lib/utils/productsUtils';
const ProductContainer = styled.div.withConfig({
  displayName: "ProductDescriptions__ProductContainer",
  componentId: "sc-1vo9003-0"
})(["display:flex;align-items:center;"]);
const DescriptionContainer = styled.span.withConfig({
  displayName: "ProductDescriptions__DescriptionContainer",
  componentId: "sc-1vo9003-1"
})(["margin-left:23px;"]);

const getStringKey = unitType => {
  switch (unitType) {
    case USER:
      return 'pricingPage.highlightedMerchCards.includes.usersStartsAt_jsx';

    case MARKETING_CONTACT_DEPRECATED:
    case CONTACT:
      return 'pricingPage.highlightedMerchCards.includes.contactsMCStartsAt_jsx';

    default:
      return null;
  }
};

const getIconWidth = productLine => {
  switch (productLine) {
    case SALES:
    case CMS:
      return 14;

    case SERVICE:
    case OPERATIONS:
      return 15;

    case MARKETING:
    default:
      return 13;
  }
};

const Product = ({
  productLine,
  body,
  productLevel,
  isNew
}) => {
  const quantityPack = useSelector(state => {
    const {
      quantityPackDetails
    } = skuSelector(state, {
      skuId: currentSkuIdForProductSelector(state, {
        productLevel,
        productLine
      })
    });
    if (!quantityPackDetails.length) return null;
    return quantityPackDetails[0];
  });
  const includedUnits = quantityPack && quantityPack.quantityUnit.includedWithProductVersion;
  const stringKey = quantityPack && getStringKey(quantityPack.quantityUnit.unitType);
  const iconWidth = getIconWidth(productLine);
  return /*#__PURE__*/_jsxs("div", {
    className: "m-y-3",
    children: [/*#__PURE__*/_jsxs(ProductContainer, {
      children: [/*#__PURE__*/_jsx(UIImage, {
        style: {
          marginRight: 10 - Math.abs(13 - iconWidth)
        },
        className: "display-inline",
        width: iconWidth,
        src: ProductLinePageIcons[productLine],
        responsive: false
      }), /*#__PURE__*/_jsx("span", {
        style: {
          fontWeight: WEB_FONT_DEMI_BOLD_WEIGHT
        },
        children: body
      }), isNew && /*#__PURE__*/_jsx(UIBadge, {
        use: "new",
        className: "m-left-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.new"
        })
      })]
    }), stringKey && /*#__PURE__*/_jsx(DescriptionContainer, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: stringKey,
        elements: {
          Number: FormattedNumber
        },
        options: {
          value: includedUnits
        }
      })
    })]
  });
};

export const ProductDescriptions = ({
  productLevel
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: CRM_SUITE_PRODUCTS[productLevel].map(productLine => /*#__PURE__*/_jsx(Product, {
      productLine: productLine,
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.pages.crmSuite.${productLine}.${productLevel}`
      }),
      productLevel: productLevel,
      isNew: productLine === CMS && productLevel === STARTER || productLine === OPERATIONS
    }, productLine))
  });
};